export default __webpack_public_path__ + "static/media/6.99633eb2.png";